import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const HeaderWrapper = styled.header`
  position: relative;
  display: flex;
  align-items: center;
  background-color: white;
  color: black;
  padding: 0 20px;
  height: 148px;
  max-width: 100vw;

  @media (max-width: 470px) {
    justify-content: space-between;
    height: 60px;
    padding: 0 10px;
  }
`;

const Logo = styled.img`
  height: 35px;
  position: absolute;
  left: 20px;
  @media (max-width: 470px) {
    position: static;
    height: 30px;
  }
`;

const NavWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 5;

  @media (max-width: 470px) {
    display: ${({ $menuOpen }) => ($menuOpen ? 'flex' : 'none')}; /* menuOpen 상태 반영 */
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background-color: white;
    flex-direction: column;
    align-items: center;
    border-top: 1px solid #eaeaea;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const Nav = styled.nav`
  ul {
    list-style-type: none;
    padding: 0;
    display: flex;
    margin: 0;
    @media (max-width: 470px) {
      flex-direction: column;
      align-items: center;
      width: 100%;
    }
  }

  li {
    margin: 0 3.5vw;
    cursor: pointer;
    @media (max-width: 470px) {
      margin: 10px 0;
    }
  }

  a {
    text-decoration: none;
    color: #9A9EA5;
    font-weight: 500;
    font-size: 20px;

    &.active {
      color: #000000;
    }

    &:hover {
      color: #000000;
    }

    @media (max-width: 470px) {
      font-size: 18px;
    }
  }
`;

const MenuIcon = styled.div`
  display: none;
  font-size: 24px;
  cursor: pointer;
  @media (max-width: 470px) {
    display: block;
  }
`;

function Header({ menuOpen, setMenuOpen }) {
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, setMenuOpen]);

  return (
    <HeaderWrapper>
      <Logo src="" alt="Logo" />
      <MenuIcon onClick={toggleMenu}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </MenuIcon>
      <NavWrapper $menuOpen={menuOpen}>
        <Nav>
          <ul>
            <li>
              <Link
                to="/"
                className={location.pathname === '/' ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                HomePage
              </Link>
            </li>
            <li>
              <Link
                to="/"
                className={location.pathname.startsWith('/location') ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                Location
              </Link>
            </li>
            <li>
              <Link
                to="/location/Chicago"
                className={location.pathname.startsWith('/items/*') ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                Products
              </Link>
            </li>
          </ul>
        </Nav>
      </NavWrapper>
    </HeaderWrapper>
  );
}

export default Header;